/**
 * Run several promises to completion, then throw if ANY rejected.
 *
 * Unlike `Promise.allSettled` (never rejects) and `Promise.all` (rejects on
 * first failure without waiting for the rest), this waits for every promise to
 * settle AND propagates failure. Used by Tasks.web's combined section refetch
 * so `useRefetchOnFocus` does not advance its staleness clock on a failed or
 * partial refetch — the next focus retries promptly (TA-10046).
 */
export const settleAllOrThrow = async (
  promises: Promise<unknown>[]
): Promise<void> => {
  const results = await Promise.allSettled(promises);
  if (results.some((r) => r.status === 'rejected')) {
    throw new Error('One or more promises rejected');
  }
};
